// import React from "react";

// const GetInTouch = () => {
//   return (
//     <>
//       {/* Contact Section */}
//       <div style={{ textAlign: "center", marginBottom: "10px" }}>
//         <h2 style={{
//           fontSize: "48px",
//           fontWeight: "700",
//           fontFamily: "Lato, sans-serif",
//           textAlign: "center"
//         }}>
//           <span style={{ color: "black" }}>Get In</span>
//           <span style={{ color: "rgb(101 235 172)", marginLeft: "5px" }}>Touch</span>
//         </h2>
//         <div style={{
//           width: "100px",
//           height: "3px",
//           backgroundColor: "rgb(0, 0, 0)",
//           margin: "0px auto",
//           marginTop:"-34px"
//         }}></div>
//       </div>

//       <div style={styles.container}>
//         {/* Left Section - Contact Info */}
//         <div style={styles.leftSection}>


//           <div style={styles.infoBox}>
//             <div>
//               <h4 style={styles.infoTitle}>Call Now</h4>
//               <p style={styles.infoText}>+91 9676222231</p>
//             </div>
//           </div>

//           <div style={styles.infoBox}>
//             <div>
//               <h4 style={styles.infoTitle}>E-mail Address</h4>
//               <p style={styles.infoText}>
//                 sandeep@srishivatravels.com <br />
//                 jai@srishivatravels.com
//               </p>
//             </div>
//           </div>

//           <div style={styles.infoBox}>
//             <div>
//               <h4 style={styles.infoTitle}>Address</h4>
//               <p style={styles.infoText}>
//                 SRI SHIVA TRAVELS
//                 Plot No.81 MIG IV Phase, APHB Colony Serilingamplly,
//                 KV Rangareddy Gachibowli, Hyderabad - 500 032, T.G. Office No. 0404971039
//               </p>
//               <p style={{ fontWeight: "", color: "black", textAlign: 'left' }}>
//                 Sandeep: 9676222231 <br /> Jai MK: 9642944442
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Right Section - Contact Form */}
//         <div style={styles.rightSection}>
//           <form style={styles.form}>
//             <div style={styles.row}>
//               <input type="text" placeholder="Name" style={styles.input} />
//               <input type="email" placeholder="E-Mail" style={styles.input} />
//             </div>

//             <div style={styles.row}>
//               <input type="text" placeholder="Phone Number" style={styles.input} />
//               <input type="text" placeholder="Subject" style={styles.input} />
//             </div>

//             <textarea placeholder="Your Message Here" style={styles.textarea}></textarea>

//             <button style={styles.button}>SUBMIT NOW ➜</button>
//           </form>
//         </div>
//       </div>

//       {/* Full-Screen Map Section */}
//       <div style={styles.mapContainer}>
//         {/* <iframe
//           title="Location Map"
//           src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7610.7433924449315!2d78.38240638937562!3d17.489761383659552!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb918dab342375%3A0x180a04af0c47f594!2sManjeera%20Trinity%20Corporate!5e0!3m2!1sen!2sin!4v1723212055136!5m2!1sen!2sin"
//           style={styles.map}
//           allowFullScreen
//           loading="lazy"
//         ></iframe> */}
//       </div>
//     </>
//   );
// };


// // Internal CSS Styles
// const styles = {
//   container: {
//     display: "flex",
//     flexWrap: "wrap",
//     justifyContent: "center",
//     alignItems: "stretch",
//     padding: "40px 20px",
//     gap: "20px",
//     maxWidth: "1100px",
//     margin: "0 auto",
//     marginTop: '-35px',
//   },
//   leftSection: {
//     flex: "1",
//     minWidth: "300px",
//     backgroundColor: "rgb(101 235 172)",
//     padding: "30px",
//     borderRadius: "10px",
//     color: "white",
//   },
//   rightSection: {
//     flex: "1.5",
//     minWidth: "300px",
//     backgroundColor: "#333",
//     padding: "30px",
//     borderRadius: "10px",
//     color: "white",
//   },
//   heading: {
//     fontSize: "24px",
//     fontWeight: "bold",
//     marginBottom: "20px",
//     textAlign: "center",
//     fontFamily: "Roboto, sans-serif",
//     marginTop: '20px',
//   },
//   infoBox: {
//     display: "flex",
//     alignItems: "center",
//     gap: "10px",
//     marginBottom: "15px",
//   },
//   infoTitle: {
//     fontSize: "18px",
//     fontWeight: "bold",
//     textAlign: "left",
//     fontFamily: "Roboto, sans-serif",
//   },
//   infoText: {
//     fontSize: "14px",
//     margin: "0",
//     textAlign: "left",
//     color: "black",
//   },
//   form: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "15px",
//   },
//   row: {
//     display: "flex",
//     flexDirection: "column", // Ensures responsiveness
//     gap: "10px",
//   },
//   input: {
//     width: "100%", // Full width for responsiveness
//     padding: "10px",
//     fontSize: "14px",
//     borderRadius: "5px",
//     border: "none",
//     outline: "none",
//   },
//   textarea: {
//     width: "100%",
//     height: "100px",
//     padding: "10px",
//     fontSize: "14px",
//     borderRadius: "5px",
//     border: "none",
//     outline: "none",
//   },
//   button: {
//     padding: "12px",
//     fontSize: "16px",
//     backgroundColor: "rgb(101 235 172)",
//     border: "none",
//     borderRadius: "5px",
//     cursor: "pointer",
//     color: "black",
//     fontWeight: "bold",
//     width: "166px",
//     textAlign: "center"
//   },
//   mapContainer: {
//     width: "100vw",
//     height: "60vh",
//     marginTop: "20px",
//     borderTop: "15px solid rgb(101 235 172)", // Thick yellow top border
//   },

//   map: {
//     width: "100%",
//     height: "100%",
//     border: "none",
//   },
// };

// // Export the component
// export default GetInTouch;


import React from "react";

const GetInTouch = () => {
  return (
    <section id="contact" style={{ paddingTop: "100px", marginTop: "-80px" }}>
    <>
    
      {/* Contact Section */}
      <div style={{ textAlign: "center", marginBottom: "25px",marginTop:"29px" }}>
        <h2
          style={{
            fontSize: "48px",
            fontWeight: "bold",
            fontFamily: "Lato, sans-serif",
            textAlign: "center",
          }}
        >
          <span style={{ color: "#4b0100" }}>Get In</span>
          <span style={{ color: "rgb(255 190 100)", marginLeft: "5px" }}>
            Touch
          </span>
        </h2>
        <div
          style={{
            width: "100px",
            height: "3px",
            backgroundColor: "rgb(0, 0, 0)",
            margin: "0px auto",
            marginTop: "-34px",
          }}
        ></div>
      </div>

      <div style={styles.container}>
        {/* Left Section - Contact Info */}
        <div style={styles.leftSection}>
          {/* Updated Contact Info */}
          <div style={styles.infoBox}>
            <div style={styles.infoContent}>
              <h4 style={styles.infoTitle}>Sharan's Inn - Medchal</h4>
              <p style={styles.infoTexts}>
                Flat No-34, 35, Uma Nagar Colony, Medchal, Secunderabad,
                Telangana 501401
              </p>
            </div>
          </div>

          <div style={styles.infoBox}>
            <div style={styles.infoContent}>
              <h4 style={styles.infoTitle}>Sharan's Inn - Bongloor</h4>
              <p style={styles.infoTexts}>
                Exit No 12, GNR Building, Gate, Opp. to Petrol Pump, Bongloor,
                Hyderabad, Telangana 501510
              </p>
            </div>
          </div>

          <div style={styles.infoBox}>
            <div style={styles.infoContent}>
              <h4 style={styles.infoTitle}>Sharan's Inn - Pragati Nagar</h4>
              <p style={styles.infoTexts}>
                Kukatpally, Hyderabad, Telangana
              </p>
            </div>
          </div>
          <div style={styles.infoBox}>
            <div style={styles.infoContent}>
              <h4 style={styles.infoTitle}>Sharan's Inn -Kukatpally</h4>
              <p style={styles.infoTexts}>
                Flat No-34, 35, Uma Nagar Colony, Medchal, Secunderabad,
                Telangana 501401
              </p>
            </div>
          </div>
        </div>

        {/* Right Section - Contact Form */}
        <div style={styles.rightSection}>
          <form style={styles.form}>
            <div style={styles.row}>
              <input type="text" placeholder="Name" style={styles.input} />
              <input type="email" placeholder="E-Mail" style={styles.input} />
            </div>

            <div style={styles.row}>
              <input
                type="text"
                placeholder="Phone Number"
                style={styles.input}
              />
              <input type="text" placeholder="Subject" style={styles.input} />
            </div>

            <textarea
              placeholder="Your Message Here"
              style={styles.textarea}
            ></textarea>

            <button style={styles.button}>SUBMIT NOW ➜</button>
          </form>
        </div>
      </div>

      {/* Full-Screen Map Section */}
      {/* <div style={styles.mapContainer}>
        <iframe
          title="Location Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7610.7433924449315!2d78.38240638937562!3d17.489761383659552!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb918dab342375%3A0x180a04af0c47f594!2sManjeera%20Trinity%20Corporate!5e0!3m2!1sen!2sin!4v1723212055136!5m2!1sen!2sin"
          style={styles.map}
          allowFullScreen
          loading="lazy"
        ></iframe>
      </div> */}
    </>
    </section>
  );
};

// Internal CSS Styles
const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "stretch",
    padding: "40px 20px",
    gap: "20px",
    maxWidth: "1100px",
    margin: "0 auto",
    marginTop: "-35px",
  },
  leftSection: {
    flex: "1",
    minWidth: "300px",
    backgroundColor: "rgb(131 42 42)", // Golden background
    padding: "30px",
    borderRadius: "10px",
    color: "black",
  },
  rightSection: {
    flex: "1.5",
    minWidth: "300px",
    backgroundColor: "#333",
    padding: "30px",
    borderRadius: "10px",
    color: "white",
  },
  heading: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "20px",
    textAlign: "center",
    fontFamily: "Roboto, sans-serif",
    marginTop: "20px",
  },
  infoBox: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "15px",
    backgroundColor: "#fff", // Light box inside the left section
    padding: "10px",
    borderRadius: "8px",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)", // Subtle shadow
  },
  infoContent: {
    textAlign: "left", // Left align the text inside the box
  },
  infoTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    fontFamily: "Roboto, sans-serif",
  },
  infoTexts: {
    fontSize: "14px",
    margin: "0",
    fontFamily: "Roboto, sans-serif",
    textAlign:'left'
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  row: {
    display: "flex",
    flexDirection: "column", // Ensures responsiveness
    gap: "10px",
  },
  input: {
    width: "100%", // Full width for responsiveness
    padding: "10px",
    fontSize: "14px",
    borderRadius: "5px",
    border: "none",
    outline: "none",
  },
  textarea: {
    width: "100%",
    height: "100px",
    padding: "10px",
    fontSize: "14px",
    borderRadius: "5px",
    border: "none",
    outline: "none",
  },
  button: {
    padding: "12px",
    fontSize: "16px",
    backgroundColor: "rgb(131 42 42)",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    color: "white",
    fontWeight: "bold",
    width: "166px",
    textAlign: "center",
  },
  mapContainer: {
    width: "100vw",
    height: "60vh",
    marginTop: "20px",
    borderTop: "15px solid rgb(101 235 172)", // Thick yellow top border
  },

  map: {
    width: "100%",
    height: "100%",
    border: "none",
  },
};

// Export the component
export default GetInTouch;
